<div class="visits-progress-bar">
    <div *ngIf="!removeNumber" class="text-right" tabindex="0">
        <span class="sr-only" translate>
            Visits
        </span>
        {{ visitsNumber | monNumber:'0,0 a' }}
    </div>
    <div class="progress-xxs progress-square" aria-hidden="true">
        <ngb-progressbar [value]="progress"></ngb-progressbar>
    </div>
</div>
